import React, { Component } from 'react';
import { Button, Stack, Checkbox } from '@envoy/polarwind';
import Select from './components/Select';

class RuleFieldMapping extends Component {

  onRemove = () => {
    this.props.onRemove(this.props.index);
  };

  onChangeEnvoyField = envoyField => {
    this.props.onChange({ ...this.props.mapping, envoyField }, this.props.index);
  };

  onChangeServiceNowColumn = serviceNowColumn => {
    this.props.onChange({ ...this.props.mapping, serviceNowColumn }, this.props.index);
  };

  onChangeIsLookupColumn = isLookupColumn => {
    this.props.onChange({ ...this.props.mapping, isLookupColumn }, this.props.index);
  };

  render() {
    const { index, envoyFieldOptions, serviceNowColumnOptions, mapping, action } = this.props;
    return (
      <Stack style={{marginTop: 0}}>
        <div style={{textAlign: 'right', paddingTop: 23}}>
          <Button onClick={this.onRemove} plain>x</Button>
        </div>
        <div style={{minWidth: 200}}>
          <Select
            label="Envoy field"
            options={envoyFieldOptions}
            value={mapping.envoyField}
            onChange={this.onChangeEnvoyField}
            required
          />
        </div>
        <div style={{minWidth: 200}}>
          <Select
            label="ServiceNow column"
            options={serviceNowColumnOptions}
            value={mapping.serviceNowColumn}
            onChange={this.onChangeServiceNowColumn}
            required
          />
        </div>
        <div style={{paddingTop: 30}}>
          <Checkbox
            label="Is lookup column"
            checked={action === 'find' ? true : action === 'always_create' ? false : mapping.isLookupColumn}
            disabled={action === 'find' || action === 'always_create'}
            onChange={this.onChangeIsLookupColumn}
          />
        </div>
      </Stack>
    );
  }
}

export default RuleFieldMapping;
